// The only two users who may see / use the Chief of Staff line (Scott + Ryan
// Greenhalgh) — by user id, NOT role. The server /cos endpoints enforce the same
// list; this is for showing/hiding the UI entry points.
export const COS_USER_IDS = ['57229538ee1f8b05d8178779', '3d0298d29b97078499f9851d'];
